/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Filter_Add_CountryInputs */



/**
* | output |
* | --- |
* | "Add a country" |
*
* @param {Tournaments_Filter_Add_CountryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_filter_add_country = /** @type {((inputs?: Tournaments_Filter_Add_CountryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Filter_Add_CountryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un pays")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir un país")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar um país")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi un paese")
	return /** @type {LocalizedString} */ ("Add a country")
});